import { useEffect, useRef } from 'react';

const channelName = 'gangacars-dashboard-sync';
const localEvent = 'gangacars-dashboard-change';

export function announceDashboardChange() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(localEvent));
  if ('BroadcastChannel' in window) {
    const channel = new BroadcastChannel(channelName);
    channel.postMessage('refresh');
    channel.close();
  }
}

export function useDashboardSync(refresh: () => void | Promise<unknown>, intervalMs = 5000) {
  const refreshRef = useRef(refresh);
  useEffect(() => { refreshRef.current = refresh; }, [refresh]);

  useEffect(() => {
    const refreshVisible = () => {
      if (document.visibilityState !== 'visible') return;
      void Promise.resolve(refreshRef.current()).catch(error => console.error('Dashboard sync failed', error));
    };
    const channel = 'BroadcastChannel' in window ? new BroadcastChannel(channelName) : null;
    if (channel) channel.onmessage = refreshVisible;
    window.addEventListener(localEvent, refreshVisible);
    window.addEventListener('focus', refreshVisible);
    document.addEventListener('visibilitychange', refreshVisible);
    const timer = window.setInterval(refreshVisible, intervalMs);
    return () => {
      window.clearInterval(timer);
      channel?.close();
      window.removeEventListener(localEvent, refreshVisible);
      window.removeEventListener('focus', refreshVisible);
      document.removeEventListener('visibilitychange', refreshVisible);
    };
  }, [intervalMs]);
}
